class NotValidatedException extends Error {
  constructor(error: string) {
    super(`Bank account not validated - ${error}`)

    this.name = 'NotValidatedException'
  }
}

export default NotValidatedException
